module.exports = __webpack_public_path__ + "img/map-geo.ab46f76e.png";